import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import JsxHelper from '../Helpers/JsxHelper';
import LookupText from '../Elements/LookupText';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FigmaBadge from '../Elements/FigmaBadge';
import urlHelper from '../Helpers/urlHelper';
import LongText from '../Elements/LongText';

class ContactComponentItem {
  constructor(item) {
    if (item === undefined) {
      this.AddressId = '';
      this.AllowBulkEmail = 'true';
      this.AllowEmail = 'true';
      this.AllowFax = 'true';
      this.AllowPhone = 'true';
      this.AllowPostalMail = 'true';
      this.AllowSendMedia = 'true';
      this.BillToClientName = '';
      this.Birthday = '';
      this.BusinessPhone = '';
      this.ClientId = '';
      this.Comments = '';
      this.ContactId = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.Email = '';
      this.Fax = '';
      this.FirstName = '';
      this.HomePhone = '';
      this.IsActive = '';
      this.JobTitle = '';
      this.LastName = '';
      this.MeadId = '';
      this.MobilePhone = '';
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.Name = '';
      this.OfficeId = '';
      this.OtherPhone = '';
      this.PrefContactMethodCode = '';
      this.Salutation = '';
      this.SapbillToContactId = '';
      this.TimeZoneOffset = '';
      this.Utcoffset = '';
      this.Vatnumber = '';
      this.WebSiteUrl = '';
      this.OfficeName = '';
      this.ClientName = '';
      this.LeadName = '';
      this.AddressName = '';
      this.AddressTypeCode = '';
      this.AddressPostalCode = '';
      this.AddressCity = '';
      this.AddressLine1 = '';
      this.AddressState = '';
      this.AddressCountryId = '';
      this.AddressCountryName = '';
      this.CreatedByUserName = '';
      this.ModifiedByUserName = '';
    } else {
      this.initialize(item);
    }
  }
  async initialize(item) {
    this.AddressId = item.addressId;
    this.AllowBulkEmail = item.allowBulkEmail;
    this.AllowEmail = item.allowEmail;
    this.AllowFax = item.allowFax;
    this.AllowPhone = item.allowPhone;
    this.AllowPostalMail = item.allowPostalMail;
    this.AllowSendMedia = item.allowSendMedia;
    this.BillToClientName = item.billToClientName;
    this.Birthday = item.birthday;
    this.BusinessPhone = item.businessPhone;
    this.ClientId = item.clientId;
    this.Comments = item.comments;
    this.ContactId = item.contactId;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.Email = item.email;
    this.Fax = item.fax;
    this.FirstName = item.firstName;
    this.HomePhone = item.homePhone;
    this.IsActive = item.isActive;
    this.JobTitle = item.jobTitle;
    this.LastName = item.lastName;
    this.LeadId = item.leadId;
    this.MobilePhone = item.mobilePhone;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOn;
    this.Name = item.name;
    this.OfficeId = item.officeId;
    this.OtherPhone = item.otherPhone;
    this.PrefContactMethodCode = item.prefContactMethodCode;
    this.Salutation = item.salutation;
    this.SapbillToContactId = item.sapbillToContactId;
    this.TimeZoneOffset = item.timeZoneOffset;
    this.Utcoffset = item.utcoffset;
    this.Vatnumber = item.vatnumber;
    this.WebSiteUrl = item.webSiteUrl;
    this.OfficeName = item.officeName;
    this.ClientName = item.clientName;
    this.LeadName = item.leadName;
    this.AddressName = item.addressName;
    this.AddressTypeCode = item.addressTypeCode;
    this.AddressPostalCode = item.addressPostalCode;
    this.AddressCity = item.addressCity;
    this.AddressLine1 = item.addressLine1;
    this.AddressState = item.addressState;
    this.AddressCountryId = item.addressCountryId;
    this.AddressCountryName = item.addressCountryName;
    this.CreatedByUserName = item.createdByUserName;
    this.ModifiedByUserName = item.modifiedByUserName;
  }

  static NameOfTheIdField() {
    return 'ContactId';
  }
  static nameOfTheItemDetailList() {
    return 'Contact';
  }
  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOn', 'ModifiedOn'];

  static BoolFields = ['IsActive'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'FirstName', label: 'First Name' },
        { name: 'OfficeName', label: 'Office' },
        { name: 'BusinessPhone', label: 'Business Phone' },
        { name: 'LastName', label: 'Last Name' },
        { name: 'Vatnumber', label: 'Tax Number' },
        { name: 'MobilePhone', label: 'Mobile Phone' },
        { name: 'JobTitle', label: 'Title' },
        { name: 'Email', label: 'E-mail' },
        { name: 'HomePhone', label: 'Home Phone' },
        {
          name: (item) => `${item.ClientName}(${item.ClientId})`,
          label: 'Client',
        },
        {
          name: (item) => urlHelper.getLinkComponent(item.WebSiteUrl),
          label: 'Website Url',
        },
        { name: 'OtherPhone', label: 'Other Phone' },
        { name: 'BillToClientName', label: 'Bill to Client' },
        { name: 'SapbillToContactId', label: 'SAP Bill to Contact Id' },
        { name: 'Fax', label: 'Fax' },
        {
          name: (item) => (item.LeadId === null ? '' : `${item.LeadName}(${item.LeadId})`),
          label: 'Lead',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={9}
              value={item.PrefContactMethodCode}
            />
          ),
          label: 'Preferred contact method',
        },
        { name: '-', label: '' },
        {
          name: 'Comments',
          label: 'Comments',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        {
          name: (item) => JsxHelper.YesNo(item.AllowEmail),
          label: 'Allow Email',
        },
        {
          name: (item) => JsxHelper.YesNo(item.AllowPhone),
          label: 'Allow Phone',
        },
        { name: (item) => JsxHelper.YesNo(item.AllowFax), label: 'Allow Fax' },
        {
          name: (item) => JsxHelper.YesNo(item.AllowBulkEmail),
          label: 'Allow Bulk Email',
        },
        {
          name: (item) => JsxHelper.YesNo(item.AllowPostalMail),
          label: 'Allow Postal Mail',
        },
        {
          name: (item) => JsxHelper.YesNo(item.AllowSendMedia),
          label: 'Allow Send Media',
        },
        { name: '-message-', label: '' },
        { name: 'CreatedByUserName', label: 'Created By' },
        { name: 'ModifiedByUserName', label: 'Modified By' },
        { name: '', label: '' },
        { name: 'CreatedOn', label: 'Created On' },
        { name: 'ModifiedOn', label: 'Modified On' },
        { name: '', label: '' },
        {
          name: 'Address',
          label: 'Address',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        { name: 'AddressName', label: 'Address Name' },
        { name: 'AddressLine1', label: 'Street' },
        { name: 'AddressState', label: 'State' },
        {
          name: (item) => (
            <LookupText
              lookupId={8}
              value={item.AddressTypeCode}
            />
          ),
          label: 'Address Type',
        },
        { name: 'AddressCity', label: 'City' },
        { name: 'AddressCountryName', label: 'Country' },
        { name: '', label: '' },
        { name: 'AddressPostalCode', label: 'Postal Code' },
        { name: '', label: '' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'ID',
        orderById: 'ID',
        data: 'ContactId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: 'Name',
        orderById: 'LastName',
        data: (item) => (
          <LongText
            text={`${item.LastName}, ${item.FirstName}`}
            maxLength={40}
          />
        ),
        minWidth: 50,
      },
      {
        label: 'Bill to Client Name',
        orderById: 'BillToClientName',
        data: (item) => (
          <LongText
            text={item.BillToClientName}
            maxLength={30}
          />
        ),
        minWidth: '120px',
      },
      {
        label: 'Office',
        orderById: 'OfficeId',
        data: 'OfficeName',
        minWidth: 50,
      },
      {
        label: 'Address Name',
        orderById: 'AddressId',
        data: (item) => (
          <LongText
            text={item.AddressName}
            maxLength={30}
          />
        ),
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Phone',
        orderById: 'BusinessPhone',
        data: 'BusinessPhone',
        type: FieldTypesEnum.Email,
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Email',
        orderById: 'Email',
        data: 'Email',
        type: FieldTypesEnum.Email,
        minWidth: 50,
      },
      {
        label: 'Active?',
        orderById: 'OfficeId',
        data: (item) => ContactComponentItem.getBadgeContent(item.IsActive),
        minWidth: 50,
      },
      {
        label: 'Actions',
        orderById: 'ContactId',
        data: ContactComponentItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getBadgeContent(item) {
    return (
      <FigmaBadge
        Active={item}
        ActiveText='Yes'
        InactiveText='No'
        width={60}
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => ContactComponentItem.editFunction(item.EvaluatorId, item),
            roleKey: 'ClientContact_faicon_CreateEdit',
          },
          {
            iconName: 'fa-solid fa-percent',
            text: 'Tax',
            onClick: () => ContactComponentItem.taxFunction(item.ContactId, item),
            roleKey: 'ClientContact_faicon_CreateEdit',
          },
        ]}
      />
    );
  }
}

export default ContactComponentItem;
